import { Component, Input } from '@angular/core';
import { ToggleableInputDirective } from '@mhe/ngx-shared/shared';
import { provideValueAccessor } from '@mhe/ngx-shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "@mhe/ngx-shared/required-indicator";
const _c0 = ["*"];
/**
 * @deprecated since version 9.0
 */
export class CheckboxComponent extends ToggleableInputDirective {
    constructor() {
        super(...arguments);
        this._required = false;
        this._inverted = false;
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = typeof value !== 'undefined' && value !== false;
    }
    get inverted() {
        return this._inverted;
    }
    set inverted(value) {
        this._inverted = typeof value !== 'undefined' && value !== false;
    }
}
CheckboxComponent.ɵfac = /*@__PURE__*/ function () { let ɵCheckboxComponent_BaseFactory; return function CheckboxComponent_Factory(t) { return (ɵCheckboxComponent_BaseFactory || (ɵCheckboxComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CheckboxComponent)))(t || CheckboxComponent); }; }();
CheckboxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["mhe-checkbox"]], inputs: { required: "required", inverted: "inverted" }, features: [i0.ɵɵProvidersFeature([provideValueAccessor(CheckboxComponent)]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 6, vars: 6, consts: [[1, "ahe-ui-checkbox"], ["type", "checkbox", 3, "change"], ["input", ""], [3, "required", "inverted"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "label", 0)(1, "input", 1, 2);
        i0.ɵɵlistener("change", function CheckboxComponent_Template_input_change_1_listener($event) { return ctx._onChangeEvent($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span");
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "mhe-required-indicator", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassProp("ahe-ui-checkbox_inverted", ctx.inverted);
        i0.ɵɵadvance(1);
        i0.ɵɵattribute("disabled", ctx.disabled ? "" : null)("required", ctx.required ? "" : null);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("required", ctx.required)("inverted", ctx.inverted);
    } }, dependencies: [i1.RequiredIndicatorComponent], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{ providers: [provideValueAccessor(CheckboxComponent)], selector: 'mhe-checkbox', template: "<label class=\"ahe-ui-checkbox\" [class.ahe-ui-checkbox_inverted]=\"inverted\">\n  <input\n    #input\n    type=\"checkbox\"\n    (change)=\"_onChangeEvent($event)\"\n    [attr.disabled]=\"disabled ? '' : null\"\n    [attr.required]=\"required ? '' : null\"\n  />\n  <span><ng-content></ng-content></span>\n  <mhe-required-indicator [required]=\"required\" [inverted]=\"inverted\"></mhe-required-indicator>\n</label>\n", styles: ["/*# sourceMappingURL=checkbox.component.css.map */\n"] }]
    }], null, { required: [{
            type: Input
        }], inverted: [{
            type: Input
        }] }); })();
